import React from "react";
import { render } from "react-dom";
import App from "./App";
import 'toastify-js/src/toastify.css';
render(<App />, document.getElementById("root"));
